import { useSelector } from 'hooks/utils';
import { selectEntriesTableParams } from 'store/data/entries';

// Rows matching the currently active dataset filter (from the entries table store).
export function useFilteredEntryCount(): number {
	return useSelector(state => selectEntriesTableParams(state.data.entries)).totalCount;
}
